import { observer } from "mobx-react";
import { Navigate, useLocation } from "react-router";
import { userInfoStore } from "Stores/UserInfoStore";

export const RedirectAccordingToAccess = observer(() => {
  let pathUrl: string;
  const location = useLocation();
  if (userInfoStore.isAuthenticated) {
    if (userInfoStore.role === "GUEST") {
      pathUrl = "/guest";
    } else if (
      location.state &&
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (location.state as any).from &&
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (location.state as any).from.pathname
    ) {
      pathUrl =
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (location.state as any).from.pathname !== "/"
          ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (location.state as any).from.pathname
          : "/dashboard";
    } else {
      pathUrl = "/dashboard";
    }
  } else {
    pathUrl = "/login";
  }

  return <Navigate to={{ pathname: pathUrl }} state={{ from: location }} />;
});
